// extracted by mini-css-extract-plugin
export default {"ratiosField":"ratiosFormField_ratiosField__ZH+0b","ratiosMultiselect":"ratiosFormField_ratiosMultiselect__Uh-0U"};